import { Component, ContentChild, TemplateRef, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'AdminCard',
  templateUrl: './AdminCard.html',
  styleUrl: './AdminCard.css'
})
export class AdminCard<T> implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Item']) {
      console.log(this.bodyTemplate);
      this.cdr.detectChanges();
    }
  }
  // Sucht im Content nach #cardBody
  @ContentChild('cardBody', { static: false }) bodyTemplate?: TemplateRef<T>;
  @Input() HeaderText: string = "";
  @Input() IsVisible: Boolean = true;
  @Input() Item: T | null = null;

  constructor(private cdr: ChangeDetectorRef) { }
 
}
